import {CurrencyPipe} from '@angular/common';
import {HttpClient} from '@angular/common/http';
import {CUSTOM_ELEMENTS_SCHEMA,ModuleWithProviders,NgModule} from '@angular/core';
import {RouterModule} from '@angular/router';
import {NgbActiveModal,NgbDateAdapter} from '@ng-bootstrap/ng-bootstrap';
import {TranslateLoader,TranslateModule} from '@ngx-translate/core';
import {NgxChartsModule} from '@swimlane/ngx-charts';
import {MyDatePickerModule} from 'mydatepicker';
import {NgMultiSelectDropDownModule} from 'ng-multiselect-dropdown';
import {NgOtpInputModule} from 'ng-otp-input';
import {RecaptchaFormsModule,RecaptchaModule} from 'ng-recaptcha';
import {ModalModule} from 'ngx-bootstrap/modal';
import {DndListModule} from 'ngx-drag-and-drop-lists';
import {GooglePlaceModule} from 'ngx-google-places-autocomplete';
import {UiSwitchModule} from 'ngx-toggle-switch';
import {CapitalizeString} from 'src/app/shared/custom-pipe/capitalize-string.pipe';
import {CustomCurrency} from 'src/app/shared/custom-pipe/currency.pipe';
import {DecimalPipe} from 'src/app/shared/custom-pipe/decimalPipe.pipe';
import {RateCurrency} from 'src/app/shared/custom-pipe/rate-currency.pipe';
import {SearchFilterPipe} from 'src/app/shared/custom-pipe/search-filter.pipe';
import {CustomCurrency2} from 'src/app/shared/custom-pipe/strikerate.pipe';
import {TrimPipe} from 'src/app/shared/custom-pipe/trim.pipe';
import {HttpLoaderFactory} from '../app.module';
import {NotificationPreferenceMySuffixDetailComponent} from '../entities/notification-preference-my-suffix';
import {
    HasAnyAuthorityDirective,
    JhiHistoryComponent,JhiLoginModalComponent,
    StaffAuthorityDirective,TdisstudioSharedCommonModule,TdisstudioSharedLibsModule,
    TwoDigitDecimaNumberDirective
} from './';
import {EsgReportService} from './ESG-Awareness/esg-report.service';
import {ActiveInactivePopUpComponent} from './active-popup/active-inactive-popup.component';
import {ActiveInactivePopupDirective} from './active-popup/active-popup.direactive';
import {BrokerHasAnyAuthorityDirective} from './auth/broker-has-authority-access.directive';
import {HasAnyAuthorityAccessDirective} from './auth/has-any-authority-access.directive';
import {HasAnyAuthorityNoAccessDirective} from './auth/has-any-authority-no-access.directive';
import {StaffAuthorityDirectiveForScope} from './auth/staff-authority-for-scope.directive';
import {StaffHasAllAuthorityDirective} from './auth/staff-has-all-authority.directive';
import {StaffHasAnyAuthorityDirective} from './auth/staff-has-any-authority.directive';
import {TextAreaAutoReSizeDirective} from './auth/textArea-auto-resize.diractive';
import {ConfirmationModalComponent} from './confirmation-modal/confirmation-modal.component';
import {ConfirmationModelService} from './confirmation-modal/confirmation-model.service';
import {DateFormatterPipe} from './custom-pipe/date-formatter.pipe';
import {DateTimeFormatterPipe} from './custom-pipe/date-time-formatter.pipe';
import {EmptyPipe} from './custom-pipe/empty.pipe';
import {FinscanStatusPipe} from './custom-pipe/finscan-status.pipe';
import {OrderPipe} from './custom-pipe/order.pipe';
import {StatusPipe} from './custom-pipe/status.pipe';
import {TonnagePipe} from './custom-pipe/tonnage.pipe';
import {UpperCaseString} from './custom-pipe/uppercase-string.pipe';
import {CustomWeight} from './custom-pipe/weight-formatter.pipe';
import {CustomPolPodComponent} from './custom-pol-pod/custom-pol-pod.component';
import {FutureHistoryComponent} from './future-history/future-history.component';
import {FutureHistoryService} from './future-history/future-history.service';
import {HistoryService} from './history/history.service';
import {InformationModelService} from './information-model/Information-model.service';
import {InformationModelComponent} from './information-model/information-model.component';
import {ItemCountComponent} from './item-count/item-count.component';
import {LoginAtraloComponent} from './login/login-atralo/login-atralo.component';
import {LoginTdisComponent} from './login/login-tdis/login-tdis.component';
import {LoginVerheyenComponent} from './login/login-verheyen/login-verheyen.component';
import {PasswordStrengthBarComponent} from './password-strenght-bar/password-strength-bar.component';
import {BlockCopyPasteDirective} from './services/block-cop-paste.service';
import {LanguageChangeService} from './services/language-change.service';
import {UserConfirmationModalComponent} from './user-confirmation-modal/user-confirmation-modal.component';
import {NgbDateMomentAdapter} from './util/datepicker-adapter';

@NgModule({
    imports: [TdisstudioSharedLibsModule,
        TdisstudioSharedCommonModule,
        ModalModule.forRoot(),
        RouterModule,
         DndListModule,
        NgxChartsModule,
        TranslateModule.forChild({
            loader: {
            provide: TranslateLoader,
            useFactory: HttpLoaderFactory,
            deps: [HttpClient]
          },
          isolate: false
      }),
        NgOtpInputModule,
        RecaptchaModule.forRoot(),
        RecaptchaFormsModule,
        NgMultiSelectDropDownModule.forRoot(),
        GooglePlaceModule,
        MyDatePickerModule,
    ],
    declarations: [
        JhiLoginModalComponent,
        JhiHistoryComponent,
        CustomWeight,
        NotificationPreferenceMySuffixDetailComponent,
        HasAnyAuthorityDirective,
        StaffAuthorityDirective,
        TwoDigitDecimaNumberDirective,
        CapitalizeString,
        UpperCaseString,
        DecimalPipe,
        SearchFilterPipe,
        CustomCurrency,
        CustomCurrency2,
        RateCurrency,
        FutureHistoryComponent,
        ConfirmationModalComponent,
        TrimPipe,
        DateTimeFormatterPipe,
        DateFormatterPipe,
        OrderPipe,
        ItemCountComponent,
        HasAnyAuthorityAccessDirective,
        HasAnyAuthorityNoAccessDirective,
        InformationModelComponent,
        PasswordStrengthBarComponent,
        StaffAuthorityDirectiveForScope,
        BrokerHasAnyAuthorityDirective,
        BlockCopyPasteDirective,
        TonnagePipe,
        StaffHasAllAuthorityDirective,
        StaffHasAnyAuthorityDirective,
        LoginVerheyenComponent,
        LoginTdisComponent,
        FinscanStatusPipe,
        StatusPipe,
        UserConfirmationModalComponent,
        TextAreaAutoReSizeDirective,
        ActiveInactivePopUpComponent,
        ActiveInactivePopupDirective,
        LoginAtraloComponent,
        EmptyPipe,
        CustomPolPodComponent
    ],
    providers: [CurrencyPipe, 
         { provide: NgbDateAdapter, useClass: NgbDateMomentAdapter },
        
        NgbActiveModal, LanguageChangeService, HistoryService, FutureHistoryService,
         ConfirmationModelService, InformationModelService, EsgReportService],
    entryComponents: [JhiLoginModalComponent, JhiHistoryComponent, FutureHistoryComponent, NotificationPreferenceMySuffixDetailComponent, ConfirmationModalComponent, InformationModelComponent,
        ItemCountComponent,PasswordStrengthBarComponent],
    exports: [
        TdisstudioSharedCommonModule,
        JhiLoginModalComponent,
        JhiHistoryComponent,
        PasswordStrengthBarComponent,
        HasAnyAuthorityDirective,
        StaffAuthorityDirective,
        TwoDigitDecimaNumberDirective,
        CapitalizeString,
        UpperCaseString,
        DecimalPipe,
        SearchFilterPipe,
        CustomCurrency,
        CustomCurrency2,
        RateCurrency,
        TranslateModule,
        UiSwitchModule,
        FutureHistoryComponent,
        NotificationPreferenceMySuffixDetailComponent,
        TrimPipe,
        DateTimeFormatterPipe,
        DateFormatterPipe,
        OrderPipe,
        DndListModule,
        ItemCountComponent,
        NgxChartsModule,
        HasAnyAuthorityAccessDirective,
        HasAnyAuthorityNoAccessDirective,
        StaffAuthorityDirectiveForScope,
        BrokerHasAnyAuthorityDirective,
        BlockCopyPasteDirective,
        TextAreaAutoReSizeDirective,
        TonnagePipe,
        StaffHasAllAuthorityDirective,
        StaffHasAnyAuthorityDirective,
        FinscanStatusPipe,
        StatusPipe,
        UserConfirmationModalComponent,
        ActiveInactivePopUpComponent,
        ActiveInactivePopupDirective,
        CustomWeight,
        EmptyPipe,
        CustomPolPodComponent
    ],
    schemas: [CUSTOM_ELEMENTS_SCHEMA]
})
export class TdisstudioSharedModule { 
    // constructor(private languageChangeService:LanguageChangeService){
    // }
    static forRoot(): ModuleWithProviders {
        return {
          ngModule: TdisstudioSharedModule,
          providers: [LanguageChangeService]
        }
      }
}
